import { useRef } from "@wordpress/element";
import Slider from "react-slick";

const TestimonialsSlider = ({ testimonials }) => {
	let sliderRef = useRef(null);

	const next = () => {
		sliderRef.slickNext();
	};
	const previous = () => {
		sliderRef.slickPrev();
	};

	var settings = {
		dots: false,
		arrows: false,
		infinite: false,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
	};

	return (
		<>
			<Slider
				ref={(slider) => {
					sliderRef = slider;
				}}
				{...settings}
			>
				{testimonials.map((testimonial, index) => (
					<div key={index} className="qasas-client-feedback">
						<p dangerouslySetInnerHTML={{ __html: testimonial.content }}></p>
						<div className="qasas-client-info">
							<img src={testimonial.avatar} alt="Client" />
							<div>
								<h4
									dangerouslySetInnerHTML={{ __html: testimonial.author }}
								></h4>
								<p
									dangerouslySetInnerHTML={{ __html: testimonial.position }}
								></p>
							</div>
						</div>
					</div>
				))}
			</Slider>

			<div className="qasas-slider-buttons">
				<button className="qasas-slider-button-pev" onClick={previous}>
					<svg
						width="18"
						height="16"
						viewBox="0 0 18 16"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M8.82672 1.04773L1.87451 7.99993L8.82672 14.9521M2.8401 7.99993L16.9376 7.99994"
							stroke="black"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				</button>
				<button className="qasas-slider-button-next" onClick={next}>
					<svg
						width="18"
						height="16"
						viewBox="0 0 18 16"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M9.04808 14.9571L16.0626 8.06773L9.1732 1.05324M15.097 8.05904L1.00006 7.93218"
							stroke="black"
							strokeWidth="2"
							strokeLinecap="round"
							strokeLinejoin="round"
						/>
					</svg>
				</button>
			</div>
		</>
	);
};

export default TestimonialsSlider;
